import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_INCREASE_REQUEST: MijnRoute = {
    path: 'hypotheken-verhogen/aanvraag',
    navigationEvent: 'toHypothekenVerhogenAanvraag',
    regex: /^\/hypotheek\/hypotheken-verhogen\/aanvraag$/,
    webcomponent: 'mijn-hypotheken-verhogen-webcomponent',
    internalPath: 'hypotheken-verhogen/aanvraag'
};
